import { render } from "./confirmados.vue?vue&type=template&id=67fb0e4e&scoped=true"
import script from "./confirmados.vue?vue&type=script&lang=js"
export * from "./confirmados.vue?vue&type=script&lang=js"

import "./confirmados.vue?vue&type=style&index=0&id=67fb0e4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fb0e4e"]])

export default __exports__